import { FeedbackFormType, FeedbackStrings, LegacyImage } from "../types/feedback.types";
import images from "../utils/images";

export const Banner = ({ banner }: { banner?: LegacyImage }) => {
  if (!banner) return null;

  return (
    <div className="c-banner-container">
      <img
        className="c-banner"
        alt="banner"
        src={typeof banner === "string" ? banner : images.maxWidth(banner.largeUri || banner.uri, 1000)}
      />
      {/* <%if (header && header.labelField) { %>
      <span class="c-banner-title"><%= (defaultValues[header.labelField]) %></span>
      <% } %> */}
    </div>
  );
};

export const Footer = ({ footer }: { footer?: LegacyImage }) => {
  if (!footer) return null;

  return (
    <img className="c-banner" alt="footer" src={typeof footer === "string" ? footer : footer.largeUri || footer.uri} />
  );
};

type HeaderProps = {
  title?: string;
  showTime?: boolean;
  time?: string;
};
export const Header = ({ title, showTime, time }: HeaderProps) => {
  // console.log("showTime", showTime, time)
  return (
    <section className="container">
      <h1 style={{ textAlign: "center" }}>{title}</h1>
      {showTime && <h2>{time}</h2>}
    </section>
  );
};

type MessageProps = {
  feedback: FeedbackFormType;
  strings?: FeedbackStrings;
};
export const Message = ({ feedback, strings }: MessageProps) => {
  const { messageHtml, message } = feedback;

  if (messageHtml) return <div dangerouslySetInnerHTML={{ __html: messageHtml }} />;
  return <p style={{ textAlign: "center", whiteSpace: "pre-line" }}>{message || strings?.feedback}</p>;
};
